// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resizable-container {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.resizable-left,
.resizable-right {
  height: 100%;
  overflow: hidden;
  min-width: 0;
}

.resize-handle {
  width: 8px;
  background-color: transparent;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  transition: background-color 0.2s ease;
  position: relative;
  flex-shrink: 0;
}

.resize-handle:hover {
  background-color: var(--accent);
}

.resize-handle-line {
  width: 2px;
  height: 40px;
  background-color: var(--border);
  border-radius: 1px;
  transition: all 0.2s ease;
}

.resize-handle:hover .resize-handle-line {
  background-color: var(--accent-foreground);
  height: 60px;
}

.resizable-container.dragging .resize-handle {
  background-color: var(--accent);
}

.resizable-container.dragging .resize-handle-line {
  background-color: var(--accent-foreground);
  height: 100vh;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .resizable-container {
    flex-direction: column;
  }

  .resizable-left,
  .resizable-right {
    width: 100% !important;
    height: 50vh;
  }

  .resize-handle {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ResizableLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".resizable-container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.resizable-left,\n.resizable-right {\n  height: 100%;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.resize-handle {\n  width: 8px;\n  background-color: transparent;\n  cursor: col-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 2px;\n  transition: background-color 0.2s ease;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.resize-handle:hover {\n  background-color: var(--accent);\n}\n\n.resize-handle-line {\n  width: 2px;\n  height: 40px;\n  background-color: var(--border);\n  border-radius: 1px;\n  transition: all 0.2s ease;\n}\n\n.resize-handle:hover .resize-handle-line {\n  background-color: var(--accent-foreground);\n  height: 60px;\n}\n\n.resizable-container.dragging .resize-handle {\n  background-color: var(--accent);\n}\n\n.resizable-container.dragging .resize-handle-line {\n  background-color: var(--accent-foreground);\n  height: 100vh;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .resizable-container {\n    flex-direction: column;\n  }\n\n  .resizable-left,\n  .resizable-right {\n    width: 100% !important;\n    height: 50vh;\n  }\n\n  .resize-handle {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
